import { render, staticRenderFns } from "./people_sidebar.vue?vue&type=template&id=5e346e74&"
import script from "./people_sidebar.vue?vue&type=script&lang=js&"
export * from "./people_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e346e74')) {
      api.createRecord('5e346e74', component.options)
    } else {
      api.reload('5e346e74', component.options)
    }
    module.hot.accept("./people_sidebar.vue?vue&type=template&id=5e346e74&", function () {
      api.rerender('5e346e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/people_sidebar.vue"
export default component.exports